import Link from "next/link";
import React from "react";
import key from "weak-key";

interface Props {
  dataDiff: unknown[];
}

export default function RunDetailsTable({ dataDiff }: Props): JSX.Element {
  const horizontalAxis = dataDiff.length > 1;
  return (
    <>
      <div className="flex flex-col border rounded max-h-96 overflow-auto mt-2 show-scrollbar">
        <div className=" overflow-x-auto show-scrollbar">
          <div className="align-middle inline-block min-w-full">
            <table className="min-w-full divide-y divide-cool-gray-200">
              {horizontalAxis ? (
                <>
                  <thead className="bg-cool-gray-50">
                    <tr className="divide-x divide-gray-200">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" />
                      {Object.keys(dataDiff?.[0] ?? ({} as any)).map((key) => (
                        <th key={key} scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {key}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {dataDiff.map((rowData: any, index) => (
                      <tr key={index} className="divide-x divide-gray-200">
                        <td key={index} className=" px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-cool-gray-50 w-8">
                          {index + 1}
                        </td>

                        {Object.keys(rowData ?? ({} as any)).map((key) => (
                          <td key={key} className="px-6 py-4 whitespace-nowrap">
                            {key == "slack_permalink" ? (
                              <Link href={rowData[key]} passHref className="text-sm text-gray-800">
                                {rowData[key]}
                              </Link>
                            ) : (
                              <div className="text-sm text-gray-900">{typeof rowData[key] === "string" ? rowData[key] : JSON.stringify(rowData[key])}</div>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </>
              ) : (
                <>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {Object.keys(dataDiff?.[0] ?? ({} as any)).map((key) => (
                      <tr key={key} className="divide-x divide-gray-200">
                        <td key={key} className=" px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-cool-gray-50 w-8">
                          {key}
                        </td>
                        {dataDiff.map((rowData: any, index) => (
                          <td key={index} className="px-6 py-4 whitespace-nowrap">
                            {key == "slack_permalink" ? (
                              <Link href={rowData[key]} passHref className="text-sm text-gray-800">
                                {rowData[key]}
                              </Link>
                            ) : (
                              <div className="text-sm text-gray-900">{typeof rowData[key] === "string" ? rowData[key] : JSON.stringify(rowData[key])}</div>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
